import { FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React, { useCallback } from 'react';
import { Form, FormControl } from 'react-bootstrap';
import { useRecoilState } from 'recoil';
import BeaconFilterItem from '../../../models/BeaconFilterItem';
import stateFilterSex from '../../../state/stateFilterSex';


const SEX_VALUES : BeaconFilterItem[] = [
    { type: "PATO", id: "PATO:0000383", label: "Female" },
    { type: "PATO", id: "PATO:0000384", label: "Male" }
];


function QuerySex() {
    const [filterSex, setFilterSex] = useRecoilState(stateFilterSex);

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, value: string) => {
        if (value !== (filterSex || {}).id) {
            const item = SEX_VALUES.find((elem) => elem.id === value) || null;
            setFilterSex(item);
        }
    }, [filterSex]);
    const value = (filterSex || {}).id || "-";
    return (
        <RadioGroup row aria-labelledby='demo-radio-buttons-group-label' name='radio-buttons-group' onChange={handleChange}>
            <FormControlLabel value='' control={<Radio />} label='Any' checked={'-' === value} />
            {
                SEX_VALUES.map((elem) => (
                    <FormControlLabel key={elem.id} value={elem.id} control={<Radio />} label={elem.label} checked={elem.id === value} />)
                )
            }
        </RadioGroup>
    );
}


export default QuerySex;
